import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import Button from "./ds/Button";
import Icon from "./ds/Icon";
import Message from "./ds/Message";
import Modal from "./ds/Modal";
import Options from "./ds/Options";
import Overlay from "./ds/Overlay";
import Textfield from "./ds/Textfield";
import { categoryService, tagService, userService } from "../container";
import { useGlobalState } from '../state';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const usernameRegex = /^[a-zA-Z0-9]+$/;

function isValidEmail(email) {
  return emailRegex.test(email);
}

function isValidUsername(username) {
  return username.length >= 4 && usernameRegex.test(username);
}

export default function Add() {
  const navigate = useNavigate();
  const { user, media } = useGlobalState();

  const [options, setOptions] = useState(false);
  const [newTag, setNewTag] = useState(false);
  const [newSection, setNewSection] = useState(false);
  const [newUser, setNewUser] = useState(false);

  const [updating, setUpdating] = useState(false);
  const [tagTitle, setTagTitle] = useState('');
  const [categoryTitle, setCategoryTitle] = useState('');
  const [userData, setUserData] = useState({
    name: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
  });


  // Options
  useEffect(() => {
    const hide = () => setOptions(false);
    document.body.addEventListener('click', hide);

    return () => document.body.removeEventListener('click', hide);
  }, []);

  function showOptions(e) {
    e.stopPropagation();
    setOptions(true);
  }

  function addTag() {
    navigate('/tags');
    setNewTag(true);
  }

  function addSection() {
    navigate('/sections');
    setNewSection(true);
  }

  function addUser() {
    navigate('/users');
    setNewUser(true);
  }

  const createTag = async () => {
    setUpdating(true);

    try {
      await tagService.create({
        media_id: media.id,
        creator_id: user.id,
        title: tagTitle,
      });

      setNewTag(false);

      toast.success('Tag creado con éxito.');
    } catch (err) {
      toast.error('Ocurrió un error inesperado al crear el tag.')
      console.error(err);
    }

    setUpdating(false);
  };

  const createCategory = async () => {
    setUpdating(true);

    try {
      await categoryService.create({
        media_id: media.id,
        title: categoryTitle,
      });

      setNewSection(false);

      toast.success('Sección creada con éxito.');
    } catch (err) {
      toast.error('Ocurrió un error inesperado al crear la sección.')
      console.error(err);
    }

    setUpdating(false);
  };

  const createUser = async () => {
    setUpdating(true);

    try {
      await userService.create({
        name: userData.name,
        last_name: userData.lastName,
        email: userData.email,
        username: userData.username,
        password: userData.password,
      });

      setNewUser(false);

      toast.success('Usuario creado con éxito.');
    } catch (err) {
      toast.error('Ocurrió un error inesperado al crear el usuario.')
      console.error(err);
    }

    setUpdating(false);
  };

  const isValidUser = userData.name &&
    userData.lastName &&
    isValidEmail(userData.email) &&
    isValidUsername(userData.username) &&
    userData.password;

  return (
    <>
      <div id="add">
        <button onClick={showOptions}>
          <Icon icon="plus"/>
        </button>

        {options && (
          <Options>
            <li onClick={() => navigate('/new-post')}><Icon icon="post" />Post</li>
            <li onClick={addTag}><Icon icon="tag" />Tag</li>
            <li onClick={addSection}><Icon icon="sections" />Sección</li>
            <li onClick={addUser}><Icon icon="person" />Usuario</li>
          </Options>
        )}
      </div>

      {newTag && (
        <Overlay>
          <Modal title="Nuevo tag" onclose={() => setNewTag(false)}>
            <Textfield
              value={tagTitle}
              onChange={e => setTagTitle(e.target.value)}
              placeholder="Nombre"
            />

            <Button
              label="Agregar"
              loading={updating}
              disabled={!tagTitle}
              onclick={createTag}
            />
          </Modal>
        </Overlay>
      )}

      {newSection && (
        <Overlay>
          <Modal title="Nueva sección" onclose={() => setNewSection(false)}>
            <Textfield
              value={categoryTitle}
              onChange={e => setCategoryTitle(e.target.value)}
              placeholder="Nombre"
            />

            <Button
              label="Agregar"
              loading={updating}
              disabled={!categoryTitle}
              onclick={createCategory}
            />
          </Modal>
        </Overlay>
      )}

      {newUser && (
        <Overlay>
          <Modal title="Nuevo usuario" onclose={() => setNewUser(false)}>
            <div id="add-user">
              <Message type="info" description="Crear nuevo usuario." />

              <div className="fields">
                <div className="name">
                  <Textfield
                    placeholder="Nombre"
                    value={userData.name}
                    onChange={e => setUserData((data) => ({ ...data, name: e.target.value }))}
                  />
                  <Textfield
                    placeholder="Apellido"
                    value={userData.lastName}
                    onChange={e => setUserData((data) => ({ ...data, lastName: e.target.value }))}
                  />
                </div>
              </div>

              <Textfield
                placeholder="ejemplo@gmail.com"
                value={userData.email}
                onChange={e => setUserData((data) => ({ ...data, email: e.target.value }))}
              />

              <Textfield
                placeholder="Username"
                value={userData.username}
                onChange={e => setUserData((data) => ({ ...data, username: e.target.value }))}
              />


              <Textfield
                placeholder="Password"
                value={userData.password}
                onChange={e => setUserData((data) => ({ ...data, password: e.target.value }))}
              />
            </div>

            <Button
              label="Registrar"
              loading={updating}
              disabled={!isValidUser}
              onclick={createUser}
            />
          </Modal>
        </Overlay>
      )}
    </>
  )
}
